export const NAT_NUM_0_10 = [
    {
        id: "Nat_Num_0",
        korean: '영',
        romanization: 'yeong',
        english: '0'
    },
    {
        id: "Nat_Num_1",
        korean: '하나',
        romanization: 'hana',
        english: '1'
    },
    {
        id: "Nat_Num_2",
        korean: '둘',
        romanization: 'dul',
        english: '2'
    },
    {
        id: "Nat_Num_3",
        korean: '셋',
        romanization: 'set',
        english: '3'
    },
    {
        id: "Nat_Num_4",
        korean: '넷',
        romanization: 'net',
        english: '4'
    },
    {
        id: "Nat_Num_5",
        korean: '다섯',
        romanization: 'daseot',
        english: '5'
    },
    {
        id: "Nat_Num_6",
        korean: '여섯',
        romanization: 'yeoseot',
        english: '6'
    },
    {
        id: "Nat_Num_7",
        korean: '일곱',
        romanization: 'ilgop',
        english: '7'
    },
    {
        id: "Nat_Num_8",
        korean: '여덟',
        romanization: 'yeodeol',
        english: '8'
    },
    {
        id: "Nat_Num_9",
        korean: '아홉',
        romanization: 'ahop',
        english: '9'
    },
    {
        id: "Nat_Num_10",
        korean: '열',
        romanization: 'yeol',
        english: '10'
    }
];

export const NAT_NUM_11_19 = [
    {
        id: "Nat_Num_11",
        korean: '열하나',
        romanization: 'yeolhana',
        english: '11'
    },
    {
        id: "Nat_Num_12",
        korean: '열둘',
        romanization: 'yeoldul',
        english: '12'
    },
    {
        id: "Nat_Num_13",
        korean: '열셋',
        romanization: 'yeolset',
        english: '13'
    },
    {
        id: "Nat_Num_14",
        korean: '열넷',
        romanization: 'yeolnet',
        english: '14'
    },
    {
        id: "Nat_Num_15",
        korean: '열다섯',
        romanization: 'yeoldaseot',
        english: '15'
    },
    {
        id: "Nat_Num_16",
        korean: '열여섯',
        romanization: 'yeolyeoseot',
        english: '16'
    },
    {
        id: "Nat_Num_17",
        korean: '열일곱',
        romanization: 'yeolilgop',
        english: '17'
    },
    {
        id: "Nat_Num_18",
        korean: '열여덟',
        romanization: 'yeolyeodeol',
        english: '18'
    },
    {
        id: "Nat_Num_19",
        korean: '열아홉',
        romanization: 'yeolahop',
        english: '19'
    }
];

export const NAT_NUM_20_29 = [
    {
        id: "Nat_Num_20",
        korean: '스물',
        romanization: 'seumul',
        english: '20'
    },
    {
        id: "Nat_Num_21",
        korean: '스물하나',
        romanization: 'seumulhana',
        english: '21'
    },
    {
        id: "Nat_Num_22",
        korean: '스물둘',
        romanization: 'seumuldul',
        english: '22'
    },
    {
        id: "Nat_Num_23",
        korean: '스물셋',
        romanization: 'seumulset',
        english: '23'
    },
    {
        id: "Nat_Num_24",
        korean: '스물넷',
        romanization: 'seumulnet',
        english: '24'
    },
    {
        id: "Nat_Num_25",
        korean: '스물다섯',
        romanization: 'seumuldaseot',
        english: '25'
    },
    {
        id: "Nat_Num_26",
        korean: '스물여섯',
        romanization: 'seumulyeoseot',
        english: '26'
    },
    {
        id: "Nat_Num_27",
        korean: '스물이곱',
        romanization: 'seumulilgop',
        english: '27'
    },
    {
        id: "Nat_Num_28",
        korean: '스물여덟',
        romanization: 'seumulyeodeol',
        english: '28'
    },
    {
        id: "Nat_Num_29",
        korean: '스물아홉',
        romanization: 'seumulahop',
        english: '29'
    }
];

export const NAT_NUM_30_39 = [
    {
        id: "Nat_Num_30",
        korean: '서른',
        romanization: 'seoreun',
        english: '30'
    },
    {
        id: "Nat_Num_31",
        korean: '서른하나',
        romanization: 'seoreunhana',
        english: '31'
    },
    {
        id: "Nat_Num_32",
        korean: '서른둘',
        romanization: 'seoreundul',
        english: '32'
    },
    {
        id: "Nat_Num_33",
        korean: '서른셋',
        romanization: 'seoreunset',
        english: '33'
    },
    {
        id: "Nat_Num_34",
        korean: '서른넷',
        romanization: 'seoreunnet',
        english: '34'
    },
    {
        id: "Nat_Num_35",
        korean: '서른다섯',
        romanization: 'seoreundaseot',
        english: '35'
    },
    {
        id: "Nat_Num_36",
        korean: '서른여섯',
        romanization: 'seoreunyeoseot',
        english: '36'
    },
    {
        id: "Nat_Num_37",
        korean: '서른일곱',
        romanization: 'seoreunilgop',
        english: '37'
    },
    {
        id: "Nat_Num_38",
        korean: '서른여덟',
        romanization: 'seoreunyeodeol',
        english: '38'
    },
    {
        id: "Nat_Num_39",
        korean: '서른아홉',
        romanization: 'seoreunahop',
        english: '39'
    }
];

export const NAT_NUM_40_49 = [
    {
        id: "Nat_Num_40",
        korean: '마흔',
        romanization: 'maheun',
        english: '40'
    },
    {
        id: "Nat_Num_41",
        korean: '마흔하나',
        romanization: 'maheunhana',
        english: '41'
    },
    {
        id: "Nat_Num_42",
        korean: '마흔둘',
        romanization: 'maheundul',
        english: '42'
    },
    {
        id: "Nat_Num_43",
        korean: '마흔셋',
        romanization: 'maheunset',
        english: '43'
    },
    {
        id: "Nat_Num_44",
        korean: '마흔넷',
        romanization: 'maheunnet',
        english: '44'
    },
    {
        id: "Nat_Num_45",
        korean: '마흔다섯',
        romanization: 'maheundaseot',
        english: '45'
    },
    {
        id: "Nat_Num_46",
        korean: '마흔여섯',
        romanization: 'maheunyeoseot',
        english: '46'
    },
    {
        id: "Nat_Num_47",
        korean: '마흔일곱',
        romanization: 'maheunilgop',
        english: '47'
    },
    {
        id: "Nat_Num_48",
        korean: '마흔여덟',
        romanization: 'maheunyeodeol',
        english: '48'
    },
    {
        id: "Nat_Num_49",
        korean: '마흔아홉',
        romanization: 'maheunahop',
        english: '49'
    }
];

export const NAT_NUM_50_59 = [
    {
        id: "Nat_Num_50",
        korean: '쉰',
        romanization: 'swin',
        english: '50'
    },
    {
        id: "Nat_Num_51",
        korean: '쉰하나',
        romanization: 'swinhana',
        english: '51'
    },
    {
        id: "Nat_Num_52",
        korean: '쉰둘',
        romanization: 'swindul',
        english: '52'
    },
    {
        id: "Nat_Num_53",
        korean: '쉰셋',
        romanization: 'swinset',
        english: '53'
    },
    {
        id: "Nat_Num_54",
        korean: '쉰넷',
        romanization: 'swinnet',
        english: '54'
    },
    {
        id: "Nat_Num_55",
        korean: '쉔다섯',
        romanization: 'swindaseot',
        english: '55'
    },
    {
        id: "Nat_Num_56",
        korean: '쉰여섯',
        romanization: 'swinyeoseot',
        english: '56'
    },
    {
        id: "Nat_Num_57",
        korean: '쉰일곱',
        romanization: 'swinilgop',
        english: '57'
    },
    {
        id: "Nat_Num_58",
        korean: '쉰여덟',
        romanization: 'swinyeodeol',
        english: '58'
    },
    {
        id: "Nat_Num_59",
        korean: '쉰아홉',
        romanization: 'swinahop',
        english: '59'
    }
];

export const NAT_NUM_60_69 = [
    {
        id: "Nat_Num_60",
        korean: '예순',
        romanization: 'yesun',
        english: '60'
    },
    {
        id: "Nat_Num_61",
        korean: '예순하나',
        romanization: 'yesunhana',
        english: '61'
    },
    {
        id: "Nat_Num_62",
        korean: '예순둘',
        romanization: 'yesundul',
        english: '62'
    },
    {
        id: "Nat_Num_63",
        korean: '예순셋',
        romanization: 'yesunset',
        english: '63'
    },
    {
        id: "Nat_Num_64",
        korean: '예순넷',
        romanization: 'yesunnet',
        english: '64'
    },
    {
        id: "Nat_Num_65",
        korean: '예순다섯',
        romanization: 'yesundaseot',
        english: '65'
    },
    {
        id: "Nat_Num_66",
        korean: '예순여섯',
        romanization: 'yesunyeoseot',
        english: '66'
    },
    {
        id: "Nat_Num_67",
        korean: '예순일곱',
        romanization: 'yesunilgop',
        english: '67'
    },
    {
        id: "Nat_Num_68",
        korean: '예순여덟',
        romanization: 'yesunyeodeol',
        english: '68'
    },
    {
        id: "Nat_Num_69",
        korean: '예순아홉',
        romanization: 'yesunahop',
        english: '69'
    }
];

export const NAT_NUM_70_79 = [
    {
        id: "Nat_Num_70",
        korean: '일흔',
        romanization: 'ilheun',
        english: '70'
    },
    {
        id: "Nat_Num_71",
        korean: '일흔하나',
        romanization: 'ilheunhana',
        english: '71'
    },
    {
        id: "Nat_Num_72",
        korean: '일흔둘',
        romanization: 'ilheundul',
        english: '72'
    },
    {
        id: "Nat_Num_73",
        korean: '일흔셋',
        romanization: 'ilheunset',
        english: '73'
    },
    {
        id: "Nat_Num_74",
        korean: '일흔넷',
        romanization: 'ilheunnet',
        english: '74'
    },
    {
        id: "Nat_Num_75",
        korean: '일흔다섯',
        romanization: 'ilheundaseot',
        english: '75'
    },
    {
        id: "Nat_Num_76",
        korean: '일흔여섯',
        romanization: 'ilheunyeoseot',
        english: '76'
    },
    {
        id: "Nat_Num_77",
        korean: '일흔일곱',
        romanization: 'ilheunilgop',
        english: '77'
    },
    {
        id: "Nat_Num_78",
        korean: '일흔여덟',
        romanization: 'ilheunyeodeol',
        english: '78'
    },
    {
        id: "Nat_Num_79",
        korean: '일흔아홉',
        romanization: 'ilheunahop',
        english: '79'
    }
];

export const NAT_NUM_80_89 = [
    {
        id: "Nat_Num_80",
        korean: '여든',
        romanization: 'yeodeun',
        english: '80'
    },
    {
        id: "Nat_Num_81",
        korean: '여든하나',
        romanization: 'yeodeunhana',
        english: '81'
    },
    {
        id: "Nat_Num_82",
        korean: '여든둘',
        romanization: 'yeodeundul',
        english: '82'
    },
    {
        id: "Nat_Num_83",
        korean: '여든셋',
        romanization: 'yeodeunset',
        english: '83'
    },
    {
        id: "Nat_Num_84",
        korean: '여든넷',
        romanization: 'yeodeunnet',
        english: '84'
    },
    {
        id: "Nat_Num_85",
        korean: '여든다섯',
        romanization: 'yeodeundaseot',
        english: '85'
    },
    {
        id: "Nat_Num_86",
        korean: '여든여섯',
        romanization: 'yeodeunyeoseot',
        english: '86'
    },
    {
        id: "Nat_Num_87",
        korean: '여든일곱',
        romanization: 'yeodeunilgop',
        english: '87'
    },
    {
        id: "Nat_Num_88",
        korean: '여든여덟',
        romanization: 'yeodeunyeodeol',
        english: '88'
    },
    {
        id: "Nat_Num_89",
        korean: '여든아홉',
        romanization: 'yeodeunahop',
        english: '89'
    }
];

export const NAT_NUM_90_99 = [
    {
        id: "Nat_Num_90",
        korean: '아흔',
        romanization: 'aheun',
        english: '90'
    },
    {
        id: "Nat_Num_91",
        korean: '아흔하나',
        romanization: 'aheunhana',
        english: '91'
    },
    {
        id: "Nat_Num_92",
        korean: '아흔둘',
        romanization: 'aheundul',
        english: '92'
    },
    {
        id: "Nat_Num_93",
        korean: '아흔셋',
        romanization: 'aheunset',
        english: '93'
    },
    {
        id: "Nat_Num_94",
        korean: '아흔넷',
        romanization: 'aheunnet',
        english: '94'
    },
    {
        id: "Nat_Num_95",
        korean: '아흔다섯',
        romanization: 'aheundaseot',
        english: '95'
    },
    {
        id: "Nat_Num_96",
        korean: '아흔여섯',
        romanization: 'aheunyeoseot',
        english: '96'
    },
    {
        id: "Nat_Num_97",
        korean: '아흔일곱',
        romanization: 'aheunilgop',
        english: '97'
    },
    {
        id: "Nat_Num_98",
        korean: '아흔여덟',
        romanization: 'aheunyeodeol',
        english: '98'
    },
    {
        id: "Nat_Num_99",
        korean: '아흔아홉',
        romanization: 'aheunahop',
        english: '99'
    }
];

export const NAT_NUM_100_900 = [
    { id: "Nat_Num_100", korean: '백', romanization: 'baek', english: '100' },
    { id: "Nat_Num_101", korean: '백하나', romanization: 'baekhana', english: '101' },
    { id: "Nat_Num_120", korean: '백스물', romanization: 'baekseumul', english: '120' },

    { id: "Nat_Num_200", korean: '두백', romanization: 'dubaek', english: '200' },
    { id: "Nat_Num_201", korean: '두백하나', romanization: 'dubaekhana', english: '201' },
    { id: "Nat_Num_220", korean: '두백스물', romanization: 'dubaekseumul', english: '220' },

    { id: "Nat_Num_300", korean: '세백', romanization: 'sebaek', english: '300' },
    { id: "Nat_Num_301", korean: '세백하나', romanization: 'sebaekhana', english: '301' },
    { id: "Nat_Num_320", korean: '세백스물', romanization: 'sebaekseumul', english: '320' },

    { id: "Nat_Num_400", korean: '네백', romanization: 'nebaek', english: '400' },
    { id: "Nat_Num_401", korean: '네백하나', romanization: 'nebaekhana', english: '401' },
    { id: "Nat_Num_420", korean: '네백스물', romanization: 'nebaekseumul', english: '420' },

    { id: "Nat_Num_500", korean: '다섯백', romanization: 'daseotbaek', english: '500' },
    { id: "Nat_Num_501", korean: '다섯백하나', romanization: 'daseotbaekhana', english: '501' },
    { id: "Nat_Num_520", korean: '다섯백스물', romanization: 'daseotbaekseumul', english: '520' },

    { id: "Nat_Num_600", korean: '여섯백', romanization: 'yeoseotbaek', english: '600' },
    { id: "Nat_Num_601", korean: '여섯백하나', romanization: 'yeoseotbaekhana', english: '601' },
    { id: "Nat_Num_620", korean: '여섯백스물', romanization: 'yeoseotbaekseumul', english: '620' },

    { id: "Nat_Num_700", korean: '일곱백', romanization: 'ilgopbaek', english: '700' },
    { id: "Nat_Num_701", korean: '일곱백하나', romanization: 'ilgopbaekhana', english: '701' },
    { id: "Nat_Num_720", korean: '일곱백스물', romanization: 'ilgopbaekseumul', english: '720' },

    { id: "Nat_Num_800", korean: '여덟백', romanization: 'yeodeolbaek', english: '800' },
    { id: "Nat_Num_801", korean: '여덟백하나', romanization: 'yeodeolbaekhana', english: '801' },
    { id: "Nat_Num_820", korean: '여덟백스물', romanization: 'yeodeolbaekseumul', english: '820' },

    { id: "Nat_Num_900", korean: '아홉백', romanization: 'ahopbaek', english: '900' },
    { id: "Nat_Num_901", korean: '아홉백하나', romanization: 'ahopbaekhana', english: '901' },
    { id: "Nat_Num_920", korean: '아홉백스물', romanization: 'ahopbaekseumul', english: '920' },
];

export const NAT_NUM_1000_9000 = [
    { id: "Nat_Num_1000", korean: '천', romanization: 'cheon', english: '1000' },
    { id: "Nat_Num_2000", korean: '두천', romanization: 'ducheon', english: '2000' },
    { id: "Nat_Num_3000", korean: '세천', romanization: 'secheon', english: '3000' },
    { id: "Nat_Num_4000", korean: '네천', romanization: 'necheon', english: '4000' },
    { id: "Nat_Num_5000", korean: '다섯천', romanization: 'daseotcheon', english: '5000' },
    { id: "Nat_Num_6000", korean: '여섯천', romanization: 'yeoseotcheon', english: '6000' },
    { id: "Nat_Num_7000", korean: '일곱천', romanization: 'ilgopcheon', english: '7000' },
    { id: "Nat_Num_8000", korean: '여덟천', romanization: 'yeodeolcheon', english: '8000' },
    { id: "Nat_Num_9000", korean: '아홉천', romanization: 'ahopcheon', english: '9000' },
];

export const NAT_NUM_10000_PLUS = [
    { id: "Nat_Num_10000", korean: '만', romanization: 'man', english: '10,000' },
    { id: "Nat_Num_20000", korean: '이만', romanization: 'iman', english: '20,000' },
    { id: "Nat_Num_30000", korean: '삼만', romanization: 'samman', english: '30,000' },
    { id: "Nat_Num_40000", korean: '사만', romanization: 'saman', english: '40,000' },
    { id: "Nat_Num_50000", korean: '오만', romanization: 'oman', english: '50,000' },
    { id: "Nat_Num_100000", korean: '십만', romanization: 'sipman', english: '100,000' },
    { id: "Nat_Num_200000", korean: '이십만', romanization: 'isipman', english: '200,000' },
    { id: "Nat_Num_500000", korean: '오십만', romanization: 'osipman', english: '500,000' },
    { id: "Nat_Num_1000000", korean: '백만', romanization: 'baekman', english: '1,000,000' },
    { id: "Nat_Num_2000000", korean: '이백만', romanization: 'ibaekman', english: '2,000,000' },
    { id: "Nat_Num_5000000", korean: '오백만', romanization: 'obaekman', english: '5,000,000' },
    { id: "Nat_Num_10000000", korean: '천만', romanization: 'cheonman', english: '10,000,000' },
    { id: "Nat_Num_50000000", korean: '오천만', romanization: 'ocheonman', english: '50,000,000' },
    { id: "Nat_Num_100000000", korean: '억', romanization: 'eok', english: '100,000,000' },
    { id: "Nat_Num_500000000", korean: '오억', romanization: 'oeok', english: '500,000,000' },
    { id: "Nat_Num_1000000000", korean: '십억', romanization: 'sibeok', english: '1,000,000,000' },
    { id: "Nat_Num_10000000000", korean: '백억', romanization: 'baekeok', english: '10,000,000,000' },
    { id: "Nat_Num_100000000000", korean: '천억', romanization: 'cheon-eok', english: '100,000,000,000' },
];
